import { render, staticRenderFns } from "./RealIntention.vue?vue&type=template&id=5ca78a8e"
import script from "./RealIntention.vue?vue&type=script&lang=js"
export * from "./RealIntention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports